import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../Auth/AuthContext";
import { socket, connectChatSocket } from "../Login/Signup/socket";

export default function GlobalChatNotifier() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user) return;

    // Connect socket on login
    connectChatSocket();

    const userId = (user.id || user._id || "").toString();

    const handleNewMessage = (msg) => {
      // Don't show toast for messages sent by self
      const senderId = (msg.senderId || "").toString();
      if (senderId === userId) return;

      // Don't show toast if user is currently on the active chat page
      if (location.pathname.includes("/chat")) return;

      const senderName = msg.senderName || "Customer";
      const messageText = msg.text || (msg.attachments?.length ? "Sent an attachment" : "New message");

      toast.info(
        <div style={{ cursor: "pointer" }}>
          <strong>💬 Message from {senderName}</strong>
          <p style={{ margin: "4px 0 0 0", fontSize: "0.85rem", opacity: 0.9 }}>
            {messageText.length > 50 ? messageText.slice(0, 50) + "..." : messageText}
          </p>
        </div>,
        {
          position: "bottom-right",
          autoClose: 5000,
          onClick: () => {
            navigate(`/vendor/${userId}/chat`);
          },
        }
      );
    };

    socket.on("new_message", handleNewMessage);

    return () => {
      socket.off("new_message", handleNewMessage);
    };
  }, [user, location.pathname, navigate]);

  return null;
}
